import { render, staticRenderFns } from "./InvoiceAlerts.vue?vue&type=template&id=6915bbff&"
import script from "./InvoiceAlerts.vue?vue&type=script&lang=js&"
export * from "./InvoiceAlerts.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceAlerts.vue?vue&type=style&index=0&id=6915bbff&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports